import { createContext } from 'react';

const AccessRightsContext = createContext({});

export default AccessRightsContext;
